<template>
  <Content @back="handleBack">
    <template v-slot:nav_left>{{ recordInfo.recordName || '--' }}--提交球员</template>
    <template v-slot:content_right>
      <div class="select_wrap">
        <div class="select_box">
          <template v-if="userRole !== 'coach'">
            <select v-model="selectVal.organUuid" class="yioks_select" @change="changeOrg">
              <option value="" v-if="organList.length !== 1">全部区体育行政部门</option>
              <option
                  v-for="item in organList"
                  :key="item.organUuid"
                  :value="item.organUuid">{{ item.organShortName }}
              </option>
            </select>
            <select v-model="selectVal.youthUuid" class="yioks_select" @change="changeCenter">
              <option value="" v-if="centerList.length !== 1">全部培训机构</option>
              <option
                  v-for="item in centerList"
                  :key="item.uuid"
                  :value="item.uuid">{{ item.youthShortName }}
              </option>
            </select>
          </template>
          <template v-else>
            <select v-model="selectVal.youthUuid" class="yioks_select" @change="changeCoachCenter">
              <option value="">全部培训机构</option>
              <option
                  v-for="item in squadCoachList"
                  :key="item.key"
                  :value="item.value">{{ item.label }}
              </option>
            </select>
          </template>

          <select
              v-model="selectVal.auditState"
              class="yioks_select"
              @change="changeQuery(true)"
          >
            <option value="">审核状态</option>
            <option value="0">待审核</option>
            <option value="1">通过</option>
            <option value="2">驳回</option>
            <option value="3">拒绝</option>
          </select>

        </div>
      </div>
      <div class="list_wrap">
        <div v-if="showList" class="table">
          <div class="thead">
            <div class="tr">
              <div class="th seq"><strong>序号</strong></div>
              <div class="th youthShortName"><strong>机构简称</strong></div>
              <div class="th playerScore"><strong>成绩积分</strong></div>
              <div class="th auditState"><strong>审核状态</strong></div>
              <div class="th opt"><strong>操作</strong></div>
            </div>
          </div>
          <div class="scrollArea">
            <vue-scroll>
              <div class="tbodyWrap">
                <div class="tbody">
                  <div
                    v-for="(item, index) in recordYouthList"
                    :key="index"
                    class="tr">
                    <div class="td seq">
                      <p>{{ index + 1 }}</p>
                    </div>
                    <div class="td youthShortName" :title="item.youthShortName">
                      <p>{{ item.youthShortName || '--' }}</p>
                    </div>
                    <div class="td playerScore">
                      <p>{{ item.playerScore || '--' }}分</p>
                    </div>
                    <template v-if="item.temporarily">
                      <div class="td auditState">
                        <p>暂时保存</p>
                      </div>
                    </template>
                    <template v-else>
                      <div class="td auditState">
                        <p>{{ item.auditState | auditState }}</p>
                      </div>
                    </template>
                    <div class="td opt">
                      <p v-if="!item.temporarily && item.auditState === 0">
                        <span class="item" @click="auditRecordPlayer(recordUuid, item.uuid)">审核</span>
                      </p>
                      <p v-else>
                        <span class="item" @click="viewRecordPlayer(recordUuid, item.uuid)">查看</span>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </vue-scroll>
          </div>
        </div>
        <yioks-loading v-if="loading"/>
        <yioks-empty v-if="empty" tips="暂时没有数据"></yioks-empty>
      </div>
      <Pagination :total="total" :page.sync="page"/>

    </template>

  </Content>
</template>

<script>

import 'vue-awesome/icons/plus'
import 'vue-awesome/icons/regular/trash-alt'
import 'vue-awesome/icons/regular/edit'
import record from '@/api/record'
import storage from '@/utils/storage'
import squadFormRule from '@/utils/formRules/squad'
import {ops} from '@/utils/scrollIndialog'
import coach from '@/api/coach'
import squad from '@/api/squad'
import _ from "lodash";

export default {
  components: {
    'Content': () => import('@/components/layout/list'),
    'Pagination': () => import('@/components/Pagination'),
  },
  mixins: [squadFormRule],
  data() {
    return {
      ops,
      recordYouthList: [],
      recordInfo: {},
      userRole: storage.get('userInfo').userRole,
      uuid: storage.get('userInfo').uuid,
      recordUuid: this.$route.query.uuid,
      recordType: this.$route.query.recordType,
      total: 0,
      pageSize: 20,
      page: 0,
      empty: false,
      showList: false,
      loading: true,
      playerUuid: '',
      playerScore: 0,
      recordYouthUuid: '',
      squadUuid: '',
      organList: [],
      centerList: [],
      squadCoachList: [],
      selectVal: {
        uuid: '',
        auditState: '',
        youthUuid: '',
        organUuid: '',
      },
    }
  },
  watch: {
    page() {
      this.changeQuery()
    }
  },

  filters: {

    auditState(val) {
      let res = '';
      switch (val) {
        case 0:
          res = '待审核';
          break;
        case 1:
          res = '通过';
          break;
        case 2:
          res = '驳回';
          break;
        case 3:
          res = '拒绝';
          break;
        default:
          res = '--';
          break;
      }
      return res;
    },
  },
  created() {
    const {page, uuid, auditState, organUuid, youthUuid} = this.$route.query
    page && (this.page = Number(page));
    uuid && (this.$set(this.selectVal, 'uuid', uuid));
    auditState && (this.$set(this.selectVal, 'auditState', auditState));
    organUuid && this.$set(this.selectVal, "organUuid", organUuid);
    youthUuid && this.$set(this.selectVal, "youthUuid", youthUuid);

    this.getRecordInfo() // 获取详情接口

    if (this.userRole !== 'coach') {
      this.getCenterList()
    } else {
      this.loadCoachCenterList();
    }
  },
  methods: {
    handleBack() {
      if(this.userRole === 'expert'){
        this.$router.push(this.$router.go(-1));
      }else{
        this.$router.push({
          path: "/record/list",
          query: {
            idx: 1,
          }
        });
      }
    },

    // 搜索
    getCenterList() {
      let data = this.uuid
      let request = coach.getCenterListByYouth
      if (this.userRole === 'organ') {
        request = coach.getCenterListByOrgan
        // data = this.uuid
      } else if (this.userRole === 'system' || this.userRole === 'admin' || this.userRole === 'expert') {
        request = coach.getCenterListBySystem
        data = ''
      } else if (this.userRole === 'youth' || this.userRole === 'trainCamp' || this.userRole === 'club') {
        request = coach.getCenterListByYouth
      } else {
        request = coach.getCenterListByOther
        data = ''
      }
      request(data).then((res) => {
        this.organList = res
        if (this.selectVal.organUuid) {
          this.centerList = this.organList.find(item => {
            return item.organUuid === this.selectVal.organUuid
          }).youthList || []
        } else {
          if (this.organList.length === 1) {
            this.selectVal.organUuid = this.organList[0].organUuid
            this.centerList = this.organList[0].youthList || []
          }
        }
        if (this.centerList.length === 1) {
          if (!this.selectVal.youthUuid) {
            this.selectVal.youthUuid = this.centerList[0].uuid
          }
        }
        this.getRecordYouthList()
      })
    },

    changeOrg() {
      this.centerList = []
      this.$set(this.selectVal, 'youthUuid', '')
      if (this.selectVal.organUuid) {
        const {youthList} = this.organList.find(item => {
          return item.organUuid === this.selectVal.organUuid
        })
        this.centerList = youthList || []
        if (this.centerList.length === 1) {
          this.$set(this.selectVal, 'youthUuid', this.centerList[0].uuid)
        }
      }
      this.changeQuery(true)
    },
    changeCenter() {
      this.changeQuery(true)
    },
    changeCoachCenter() {
      this.changeQuery(true)
    },


    // 教练获取搜索项可选内容
    loadCoachCenterList() {
      const _ = require('lodash');
      squad.getSquadListCoachAllToCoach()
        .then(res => {
          if (res.code) {
            this.$message.error(res.msg)
            return
          }
          const uni_selectYouthList = _.unionBy(res, "youthUuid");
          this.squadCoachList = uni_selectYouthList.map((item) => ({
            label: `${item.organShortName} - ${item.youthShortName}`,
            value: item.youthUuid,
            key: JSON.stringify({squadUuid: item.squadUuid, youthUuid: item.youthUuid, organUuid: item.organUuid})
          }));
          this.getRecordYouthList()
        })
    },

    // 编辑详情接口
    getRecordInfo() {
      this.loading = true
      record.getRecordInfo(this.recordUuid).then(res => {
        if (res.code) {
          this.$message.error(res.msg)
        }
        this.recordInfo = res;
        this.loading = false;
      }).catch(err => {
        this.loading = false
        console.error(err)
      })
    },

    // 获取列表
    getRecordYouthList() {
      this.loading = true
      this.empty = false
      this.showList = false
      let request
      request = record.recordYouthToPlayerListSystem
      request({
        page: this.page,
        size: this.pageSize,
        recordUuid: this.recordUuid,
        auditState: this.selectVal.auditState,
        youthUuid: this.selectVal.youthUuid,
        organUuid: this.selectVal.organUuid,
      }).then((res) => {
        this.loading = false
        this.total = res.totalElements
        if (res.content.length) {
          this.recordYouthList = res.content
          this.showList = true
        } else {
          this.empty = true
        }
      }).catch(err => {
        this.loading = false
        console.error(err)
      })
    },

    changeQuery(flag) {
      if (flag) this.page = 0
      this.$router.replace({
        path: this.$route.path,
        query: {
          page: this.page,
          uuid:this.selectVal.uuid,
          auditState: this.selectVal.auditState,
          youthUuid: this.selectVal.youthUuid,
          organUuid: this.selectVal.organUuid,
        }
      })
      this.getRecordYouthList()
    },

    viewRecordPlayer(recordUuid, uuid) {
      this.$router.push({
        path: 'addRecordYouthToPlayer',
        query: {
          type: 'view',
          recordUuid,
          uuid,
        }
      })
    },

    auditRecordPlayer(recordUuid, uuid) {
      this.$router.push({
        path: 'addRecordYouthToPlayer',
        query: {
          type: 'audit',
          recordUuid,
          uuid,
        }
      })
    },


  }
}
</script>

<style lang="stylus" scoped>
@import '~@/assets/css/variable'
.list_wrap
  flex 1
  overflow hidden

  .table {
    display flex
    flex-direction column
    flex 1
    width: 100%;

    .thead, .tbody {
      border: 1px solid $color_white;
    }

    .thead {
      margin: 0 40px;

      .tr {
        height: 45px;
        display: flex;
      }
    }

    .scrollArea {
      height: 425px;
      padding-bottom 15px
      /*flex 1 */
      /*overflow hidden*/
    }

    .tbodyWrap {
      display block
      // padding: 0 40px;
    }

    .tbody {
      display block
      width 810px
      margin-left auto
      margin-right auto
      max-width: 810px;
      border-top: none;
      border-bottom: none;

      .tr {
        height: 49px;
        display: flex;
        border-bottom: 1px solid $color_white;
      }
    }

    .th, .td {
      height: 100%;
      /*flex: 1 1 auto;*/
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: $font_size_medium;
      border-right: 1px solid $color_white;
    }

    .th:last-child, .td:last-child {
      border-right: none;
    }

    .td {
      p {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        color: $color_white;
      }
    }

    .seq {
      width 10%
    }

    .youthShortName {
      width 40%
    }

    .playerScore {
      width 20%
    }

    .auditState {
      width: 20%;
    }

    .opt {
      width: 10%;

      p {
        width 100%
        text-align center

        .item {
          cursor: pointer;
          user-select: none;
          color $green_color
        }

        .split {
          margin 0 5px
        }
      }
    }
  }

.demo-ruleForm
  height 475px

.tip
  margin-top 10px
  color red
  width 100%
  text-align center
  word-break break-word

.nav_wrap {
  display: flex;
  justify-content: space-between;
  font-size: 16px;

  .nav_list {
    display: flex;

    .nav_item {
      cursor: pointer;
      user-select: none;
      padding: 10px 15px;

      &.active {
        background: $green_color;
      }
    }
  }
}
</style>

